/*var START_DATE = new Date("June 21, 2021 00:00:01"); // put in the starting date here
var INTERVAL = 42; // in seconds
var INCREMENT = 1; // increase per tick
var START_VALUE = 1692280; // initial value when it's the start date
var count = 0;



(function() {
   var msInterval = INTERVAL * 1000;
var now = new Date();
count = parseInt((now - START_DATE)/msInterval) * INCREMENT + START_VALUE;
document.getElementById('bottle-counter').innerHTML = count.toLocaleString();
setInterval("count += INCREMENT; document.getElementById('bottle-counter').innerHTML = count.toLocaleString();", msInterval);
})();*/



//smooth scrolling from css-tricks

$('a[href*="#"]:not([href="#"])').click(function() {

    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
        var target = $(this.hash);

        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top-118
            }, 1000);
            return false;
        }
    }
});